<template>
  <div
    @click="toggleDarkMode"
    class="toggle"
    :class="{ lightToggle: !isDarkMode, darkToggle: isDarkMode }"
  >
    <div
      class="toggleSwitch"
      :class="{ toggleLeft: !isDarkMode, toggleRight: isDarkMode }"
    >
      <img v-if="!isDarkMode" src="@/assets/sun.svg" />
      <img v-if="isDarkMode" src="@/assets/moon.svg" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ThemeSwitch",
  computed: {
    isDarkMode() {
      return this.$store.getters.isDarkMode;
    }
  },
  methods: {
    toggleDarkMode() {
      this.$store.commit("toggleDarkMode");
    }
  }
};
</script>

<style lang="scss" scoped>
.toggle {
  border-radius: 10px;
  width: 175px;
  margin: 50px auto;
  display: flex;
  box-sizing: border-box;
}

.lightToggle {
  background: linear-gradient(328.85deg, #f7fcfc 0%, #fafcfa 100%);
  border: 1px solid rgba(0, 0, 0, 0.04);
  box-shadow: inset 0px 5px 10px rgba(0, 0, 0, 0.1);
}

.darkToggle {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: inset 0px 5px 10px rgba(255, 255, 255, 0.1);
}

.toggleSwitch {
  border-radius: 8px;
  margin: 2px;
  padding: 15px 35px;
}

.toggleLeft {
  transform: translateX(0);
  background: #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.toggleRight {
  transform: translateX(92%);
  background: #121212;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}
</style>
